module.exports = __webpack_public_path__ + "img/signup-trusted-by.06aaa926.png";